import { memo } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

// -----------------------------------------------------------------------------

const OrganizationFindingsInboxNoFindings = memo(
  function OrganizationFindingsInboxNoFindings(): JSX.Element {
    return (
      <Stack padding={2}>
        <Box textAlign="center">There are no findings</Box>
        <Box textAlign="center">with the current filters.</Box>
      </Stack>
    );
  }
);

export default OrganizationFindingsInboxNoFindings;

// -----------------------------------------------------------------------------
